/**
 * Helpers shared between the right-rail outline and the loop body — flat tree
 * traversal for the outline, plus a scroll-into-view utility wired to the
 * `id="qc-step-${id}"` anchors on each step row.
 */
import { TransformStep } from "stores/queryBuilderStore"

export interface OutlineRow {
  step: TransformStep
  depth: number
  /** 1-based index within the step's own container, for the leading marker. */
  ordinal: number
}

export const flattenForOutline = (
  steps: TransformStep[],
  depth = 0,
  out: OutlineRow[] = []
): OutlineRow[] => {
  steps.forEach((step, i) => {
    out.push({ step, depth, ordinal: i + 1 })
    if (step.type === "loop" && step.body.length > 0) {
      flattenForOutline(step.body, depth + 1, out)
    }
  })
  return out
}

export const scrollToStep = (stepId: string): void => {
  const el = document.getElementById(`qc-step-${stepId}`)
  if (!el) return
  el.scrollIntoView({ behavior: "smooth", block: "center" })
  // Briefly flash the row so the eye lands on it after the scroll settles.
  el.setAttribute("data-flash", "true")
  window.setTimeout(() => el.removeAttribute("data-flash"), 900)
}

/** Switch the loop body's literal-values editor from inline chips to a
 *  modal textarea once the user has more entries than fit comfortably. */
export const LITERAL_EXPAND_THRESHOLD = 6
